import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../images/my_btn_mb_w.png';
import { useAppContext } from 'utils/store';
import * as fireonApi from "../../apis/FireOnApi";
import { apiWrapper } from 'apis/CommonApi';
import { getStatusClassName, getStatusColorClassName, getStatusImage, getStatusName } from 'utils/common';

export default function DeleteFireOnItemComponent(props) {
    return (
        <>
            <div className="viewBoard fireOnBoard">
                <TopBoard header={props.header} />
                <StateBoard />
            </div>
        </>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src={logo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">대상물 삭제</p>
                </div>
                {header}
            </div>
        </>
    );
};

const StateBoard = () => {
    const [dataSource, setDataSource] = useState([]);
    const [checkedIds, setCheckedIds] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingObjectList();
            if (status === true) {
                setDataSource(data);
            } else {
                alert(`${data}`);
            }
        })
    }

    const handleDeleteDB = () => {
        if (window.confirm("삭제하시겠습니까?")) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.bulkDeleteFireFightingObjectDB(checkedIds);
                alert(`${data}`)

                //삭제 성공 시 새로고침
                if (status === true) {
                    getData();
                }
            });
        }
    }

    const handleDelete = () => {
        if (window.confirm("삭제하시겠습니까?")) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.bulkDeleteFireFightingObjectUser(checkedIds);
                alert(`${data}`)

                //삭제 성공 시 새로고침
                if (status === true) {
                    getData();
                }
            });
        }
    }

    const handleCancel = () => {
        setCheckedIds([]);
    }

    const handleChangeCheck = (e, id) => {
        const isChecked = e.currentTarget.classList.contains('chkItem');
        if (!isChecked) {
            //체크안된 항목 선택 시 체크하도록 해당 id 추가
            setCheckedIds([...checkedIds, id]);
        } else {
            //체크된 항목 선택 시 체크해제하도록 해당 id 제거
            setCheckedIds(checkedIds.filter((a) => a !== id));
        }
    };

    return (
        <div className="stateBoard stateTileBoard">
            {checkedIds.length > 0 && (
                <div className="toolbar" style={{ display: 'block' }}>
                    <div className="wrap_inner">
                        <button className="btn_tb btn_tbDbDel" onClick={handleDeleteDB} >DB 삭제</button>
                        <button className="btn_tb btn_tbDel" onClick={handleDelete}>삭제</button>
                        <button className="btn_tb btn_tbCancle" onClick={handleCancel}>취소</button>
                    </div>
                </div>
            )}
            <div className="wrap_state_current">
                <div className="all_current">
                    <i className="x-icon icon_info"></i>
                    다중선택이 가능합니다.
                </div>
            </div>
            <div className="wrap_state">
                {dataSource && dataSource.length > 0 &&
                    dataSource.map((item, index) => (
                        <ItemState
                            id={item.id}
                            status={item.status}
                            buildingName={item.buildingName}
                            serialNumber={item.serialNumber}
                            address={`${item.roadAddress} ${item.roadAddressDetail}`}
                            checkedIds={checkedIds}
                            handleChangeCheck={handleChangeCheck} />
                    ))}
            </div>
        </div>
    );
};

const ItemState = ({ id, status, buildingName, serialNumber, address, checkedIds, handleChangeCheck }) => {
    return (
        <div className={`item_state ${getStatusClassName(status)} ${checkedIds.includes(id) ? 'chkItem' : ''}`} onClick={(e) => handleChangeCheck(e, id)}>
            <div class="item-status-img">
                <img src={getStatusImage(status)} alt="fire-on" />
            </div>
            <div className="wrap_title_item">
                <p className="title_item">{buildingName}</p>
                <div className="adr_item">
                    <p className="serial_Code">{serialNumber}</p>
                    <span className="bar"></span>
                    <p className="text_adr">{address}</p>
                </div>
            </div>
            <div className="wrap_state_item">
                <div className={`cir_state ${getStatusColorClassName(status)}`}></div>
                <p className="title_state">{getStatusName(status)}</p>
            </div>
        </div>
    );
};